// imports
import Component from 'minsky-kit/js/components/Component';
import Tab from './Tab';

// private statics
const VERSION = '1.0.0';

// class definition
export default class Tabs extends Component {
    // constructor
    constructor (args = {}, objectName = 'Tabs') {
        args.debug = args.debug || false;

        // super
        super(args, objectName);

        this.tabs = args.tabs;
        this.contentWrapper = this.$el.querySelector('.tabs__content');
        this.triggerList = this.$el.querySelector('.tabs__triggers');
        this.activeIndex = args.activeIndex ? args.activeIndex : 1;
        this.activeTab = false;
        this.tabDirectory = {};
        // prep tabs html
        this.prep();
        // set intial active
        this.activate(this.activeIndex);
    }

    // methods
    prep () {
        for (let i = 0; i < this.tabs.length; i++) {
            const tab = this.tabs[i];
            // create list item trigger
            const trigger = document.createElement('li');
            trigger.classList.add('tabs__trigger');
            trigger.innerHTML = `<a class="tabs__trigger-button ${tab.disabled ? 'disabled' : ''}" href="#" data-tab-id="${i + 1}">${tab.trigger.innerHTML}</a>`;
            // trigger listener
            if(!tab.disabled) {
                trigger.querySelector('a').addEventListener('click', this.blm.add('onTriggerClick', onTriggerClick));
            }
            // set trigger in object
            tab.trigger = trigger;
            // set tab id for content
            tab['component'] = new Tab({
                el: tab.content,
                id: i + 1,
            });
            // save tab content parent
            tab['contentParent'] = tab.content.parentNode;
            // initial state
            tab.component.hide();
            // append childs
            this.triggerList.appendChild(trigger);
            this.contentWrapper.appendChild(tab.component.el);
            // set tab in tab directory
            this.tabDirectory[`${i + 1}`] = tab;
        }
    }

    activate (id) {
        // deactivate current tab
        if (this.activeTab) {
            this.activeTab.component.hide();
            this.activeTab.trigger.classList.remove('tabs__trigger--active');
        }

        // show tab
        this.activeTab = this.tabDirectory[id];
        this.activeTab.component.show();
        // add active class on trigger
        this.activeTab.trigger.classList.add('tabs__trigger--active');
        this.dispatch('tabChanged', {tabId: id});
    }

    get (id) {
        return this.tabDirectory[id];
    }

    destroy () {
        // super destroy
        this.tabs.forEach((tab) => {
            tab.contentParent.appendChild(tab.component.el);
            tab.trigger.parentNode.removeChild(tab.trigger);
            tab.component.destroy();
        });

        super.destroy();
    }

    // getters & setters
    static get version () { return VERSION; }
}

// Utils

// Event handlers
function onTriggerClick (e) {
    e.preventDefault();
    this.activate(e.currentTarget.dataset.tabId);
}

const getUrlParameter = (sParam) => {
    const sPageURL = window.location.search.substring(1);
    const sURLVariables = sPageURL.split('&');
    let sParameterName;
    let i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
};
